import { useTranslation } from "react-i18next";
import type { Locale } from "@/shared/utils";
import { formatMoneyKzt } from "@/shared/utils";
import type { MoneyAmount } from "../../../types";

interface BalanceCardProps {
  balance: MoneyAmount;
  locale: Locale;
}

export default function BalanceCard({ balance, locale }: BalanceCardProps) {
  const { t } = useTranslation("BankingPage");

  return (
    <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl p-6 text-white">
      <p className="text-sm opacity-80 mb-1">{t("balance.title")}</p>
      <p className="text-3xl font-bold">
        {balance.currency === "KZT"
          ? formatMoneyKzt(balance.amount, locale)
          : `${balance.amount.toLocaleString()} ${balance.currency}`}
      </p>
    </div>
  );
}
